// removed by extract-text-webpack-plugin
module.exports = {"column":"column__column___7a9pG","column-label":"column__column-label___32sUz","columnLabel":"column__column-label___32sUz","label":"column__label___3qeh2","highlighted":"column__highlighted___38Od1","can-drop":"column__can-drop___2VoCL","canDrop":"column__can-drop___2VoCL","hover":"column__hover___1o3-P"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/column.css
// module id = 810
// module chunks = 0